const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
});

export const formatCurrency = (value: number): string => {
    return formatter.format(value);
};
